// Partner role positions (proposal stage). Shared by Proposals and App Configuration › Default Roles.
export const PARTNER_POSITIONS = [
  { id: 'lead', name: 'Lead', defaultPercent: 2, description: 'Brought in the lead', editable: false, maxPercent: 10 },
  { id: 'sales', name: 'Sales', defaultPercent: 8, description: 'Closed the deal, sales lead', editable: false, maxPercent: 10 },
  { id: 'support', name: 'Sales Support', defaultPercent: 3, description: 'Helped close the deal', editable: false, maxPercent: 10 },
  { id: 'client_pm', name: 'Client Relations', defaultPercent: 5, description: 'Manages the Client Relations', editable: false, maxPercent: 10 },
  { id: 'team_pm', name: 'Team Project Manager', defaultPercent: 5, description: 'Manages the team and the project', editable: false, maxPercent: 10 },
  { id: 'administration', name: 'Administration', defaultPercent: 5, description: 'Billing, management, detail flow, advice', editable: false, maxPercent: 10 },
  { id: 'company', name: 'Company', defaultPercent: 7, description: 'Company taxes and fees', editable: false, maxPercent: 10 },
];

export const isNobodyRole = (role) =>
  role?.entityId == null && String(role?.entityName || '').toLowerCase() === 'nobody';

// Default roles for a new proposal: the saved App Configuration defaults (config.defaultPartnerRoles)
// layered over the built-in position defaults. Saved entities that no longer exist fall back to Unassigned.
export const buildDefaultPartnerRoles = (savedDefaults = [], entities = []) => {
  const saved = Array.isArray(savedDefaults) ? savedDefaults : [];
  const entityList = Array.isArray(entities) ? entities : [];
  return PARTNER_POSITIONS.map((pos) => {
    const role = {
      positionId: pos.id,
      positionName: pos.name,
      entityId: null,
      entityName: '',
      percent: Number(pos.defaultPercent ?? 5),
      editable: pos.editable,
    };
    const savedRole = saved.find((r) => r && r.positionId === pos.id);
    if (!savedRole) return role;
    if (isNobodyRole(savedRole)) {
      return { ...role, entityName: 'Nobody', percent: 0 };
    }
    const percent = Number(savedRole.percent);
    if (Number.isFinite(percent)) role.percent = percent;
    if (savedRole.entityId) {
      const entity = entityList.find((e) => e.id === savedRole.entityId);
      // Keep the saved assignment while entities are still loading
      if (entity || entityList.length === 0) {
        role.entityId = savedRole.entityId;
        role.entityName = entity?.entityName || savedRole.entityName || '';
      }
    }
    return role;
  });
};
